import React from 'react';
import { Field } from 'react-final-form';

import { Popper } from '@xsolla/ui-core';
import { ChevronUpDown, CrossCircle } from '@xsolla/ui-icons';

import { getRandomString } from '../../../utils';
import CustomList from './CustomList';
import { DropdownIconWrapper, Pill, PillDeleteButton, Select } from './style';
import { ListItems } from './types';

type Props = {
  name: string;
  items: ListItems;
  placeholder?: string;
  dataTestId?: string;
};

const MultiSelect = ({ name, dataTestId, items, placeholder, ...rest }: Props): JSX.Element => {
  const renderValues = (values: string[], onChange: (data: string[]) => void) => {
    const removeItem = (value: string) => {
      onChange([...values.filter((el) => el !== value)]);
    };

    return (
      <>
        {values.map((value) => {
          return (
            <Pill key={getRandomString()}>
              {items.find((item) => item.value === value)?.children}
              <PillDeleteButton
                look="icon"
                palette="action"
                onClick={(e) => {
                  e.stopPropagation();
                  removeItem(value);
                }}>
                <CrossCircle size={16} />
              </PillDeleteButton>
            </Pill>
          );
        })}
      </>
    );
  };

  return (
    <>
      <Field name={name}>
        {({ input, meta }) => (
          <Popper
            arrowOffset={32}
            disableAutoClose
            entry={<CustomList items={items} onChange={input.onChange} value={input.value} />}
            offset={6}
            placement="bottom-start"
            stretched>
            {(props) => (
              <>
                <Select data-test-id={dataTestId} {...rest} {...props}>
                  {input.value && !!input.value.length ? (
                    <>{renderValues(input.value, input.onChange)}</>
                  ) : (
                    <p>{placeholder}</p>
                  )}
                  <DropdownIconWrapper>
                    <ChevronUpDown />
                  </DropdownIconWrapper>
                </Select>
              </>
            )}
          </Popper>
        )}
      </Field>
    </>
  );
};

export default MultiSelect;
